module.exports = __webpack_public_path__ + "img/SB.abcab1e8.png";